module.exports = __webpack_public_path__ + "media/images/vp/headerimg.desk-4d684aeaa5172406996bd2d8b6d24bcd.jpg";